<br>
<div class="col-md-10">
  <p-table #dt [columns]="cols" [value]="electablecommittees" [paginator]="false" [autoLayout]="true">
    <ng-template pTemplate="caption">
      <p class="rubrik">Hantera Electable_COM</p>
      <div class="d-flex justify-content-start gap-2"><button class="btn border" (click)="resetFilter()" title="Rensa filter">Rensa filter</button><button class="btn border"
            (click)="exportToCSV()">Excel</button><button class="btn btn-border" (click)="add()">Lägg till</button></div>
      <br>
      
      <div>
        <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
        <input type="text" #globalfilter pInputText size="50" placeholder="Globalt filter" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
      <span class="ms-2">Antal poster: {{electablecommittees?.length}}</span>
      </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr style="background-color: whitesmoke;font-weight:bold;border:1px solid lightgrey;">
        <td colspan="2" style="border:1px solid lightgrey;">Utskott</td>
        <td colspan="2" style="border:1px solid lightgrey;">Institution</td>
        <td colspan="2" style="border:1px solid lightgrey;"></td>
      </tr>
      <tr>
        <th *ngFor="let col of columns" [pSortableColumn]="col.field">
          {{col.header}}
          <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order">
          </p-sortIcon>
        </th>
        <th>Action</th>
      </tr>
      <tr *ngIf="institutiontypes.length > 0">
        <th *ngFor="let col of columns" [ngSwitch]="col.field">
          <p-select appendTo="body" *ngSwitchCase="'institutionTypeIdName'" [options]="institutiontypes" [style]="{'width':'100%', 'height':'40px'}" (onChange)="dt.filter($event.value, 'institutionTypeId', 'equals')"></p-select>
          <input *ngSwitchCase="'institutionIdName'" pInputText type="text" [value]="dt.filters['institutionIdName'] ? dt.filters['institutionIdName'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
          <input *ngSwitchCase="'committeeName'" pInputText type="text" [value]="dt.filters['committeeName'] ? dt.filters['committeeName'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
          <input *ngSwitchCase="'committeeAbbreviation'" pInputText type="text" [value]="dt.filters['committeeAbbreviation'] ? dt.filters['committeeAbbreviation'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
        </th>
        <th style="text-align: center;">{{officecommittees?.length}}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-i="rowIndex" let-columns="columns">
      <tr [pSelectableRow]="rowData">
        <td *ngFor="let col of columns">
          {{rowData[col.field]}}
        </td>
        <td><span style="display: inline-block;"><i class="fa fa-trash" style="font-size:12px;" (click)="remove(rowData)" title="Radera aktuell electable committee"></i></span></td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog header="Lägg till Electable Committee" [(visible)]="display" [closable]="true" appendTo="body" position="center" modal="true" maximizable="true">
  <app-admin-electable-committees-add [committees]="committees" [institutions]="institutions" [institutiontypes]="institutiontypes" (doSave)="saveElectableCommittees($event)" (doCancel)="cancelAdd()"></app-admin-electable-committees-add>
</p-dialog>
